import { render, staticRenderFns } from "./ProductsSearchPopup.vue?vue&type=template&id=6e365b2a&scoped=true&"
import script from "./ProductsSearchPopup.vue?vue&type=script&lang=js&"
export * from "./ProductsSearchPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSearchPopup.vue?vue&type=style&index=0&id=6e365b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e365b2a",
  null
  
)

export default component.exports